import http from "plugins/axios";

export default {
  //更新后的查询所有用户信息
  getUserList({
    page,
    size,
    userId,
    channelId,
    channelUserId,
    startTime,
    endTime,
    type
  }) {
    return http.get({
      url: `/ta/admin/channel/trade/getUserTradePage?page=${page}&size=${size}&type=${type}&userId=${userId}&channelUserId=${channelUserId}&channelId=${channelId}&startTime=${startTime}&endTime=${endTime}`,
    });
  },
  // 添加备注
  addRemark({ channelId, userId, remarks }) {
    return http.post({
      url: `/channel/user/addRemark?channelId=${channelId}&remarks=${remarks}&userId=${userId}`,
    });
  },

  //成交汇总
  getDetail({ userId, channelId, channelUserId, startTime, endTime ,type}) {
    return http.get({
      url: `/ta/admin/channel/trade/getTotalInfo?userId=${userId}&type=${type}&channelId=${channelId}&channelUserId=${channelUserId}&startTime=${startTime}&endTime=${endTime}`,
    });
  },
  //获取币种列表
  getCoinList() {
    return http.get({
      url: "/channel/common/coinList",
    });
  },
  //返佣统计记录
  getDetailRecord({ time, channelId }) {
    return http.get({
      url: `/channel/rebate/info?channelId=${channelId}&time=${time}`,
    });
  },
};
